import React from 'react';

import utils from 'utils';

import CommonButton from 'components/Buttons/CommonButton';
import { useDispatch, useSelector } from 'react-redux';
import selectors from 'state/selectors';
import actions from 'state/actions';
import { GetNopoVendorResponse } from 'models/response';
import { actionType } from 'utils/constants';

const AddTemplate = () => {
  const t = utils.intl.useTranslator();

  const editRowID = useSelector(selectors.configurator.getEditedRowAP2ID);
  const templateList = useSelector(selectors.configurator.getTemplateAP2List);
  const dispatch = useDispatch();
  const { row: selectedNOPORow } = useSelector(selectors.modal.getModalProps);

  const addRow = async () => {
    if (selectedNOPORow) {
      const { supplierCode: vendorCode, companyName } = selectedNOPORow as GetNopoVendorResponse;

      const obj = {
        id: -1,
        newRow: true,
        companyName: companyName,
        vendorCode: vendorCode,
      };
      dispatch(actions.configurator.setTemplateAP2List([obj, ...templateList]));
      dispatch(actions.configurator.setEditedRowAP2ID(-1));
      dispatch(actions.configurator.setIsAddP2Template(true));
    }
  };

  return (
    <CommonButton
      id="add-template"
      disabled={
        editRowID !== null ||
        !utils.user.isActionByCompanyActive(actionType.ADD_AP2_TEMPLATE, selectedNOPORow.companyName)
      }
      action={() => {
        addRow();
      }}
      scope="tertiary"
      value={t('add')}
      customIcon="plus"
    />
  );
};

export default AddTemplate;
